// Re-export VietMeetJS from the library vietmeet-lib to (the other features
// of) the project vietmeet.
import VietMeetJS from './_';
export { VietMeetJS as default };
// XXX Re-export the properties exported by VietMeetJS in order to prevent
// undefined imported VietMeetJS. It may be caused by import cycles but I have
// not confirmed the theory.
export const analytics = VietMeetJS.analytics;
export const browser = VietMeetJS.util.browser;
export const VietMeetAudioTranslationErrors = VietMeetJS.errors.audioTranslation;
export const VietMeetConferenceErrors = VietMeetJS.errors.conference;
export const VietMeetConferenceEvents = VietMeetJS.events.conference;
export const VietMeetConnectionErrors = VietMeetJS.errors.connection;
export const VietMeetConnectionEvents = VietMeetJS.events.connection;
export const VietMeetConnectionQualityEvents = VietMeetJS.events.connectionQuality;
export const VietMeetDetectionEvents = VietMeetJS.events.detection;
export const VietMeetE2ePingEvents = VietMeetJS.events.e2eping;
export const VietMeetIceRestartReason = VietMeetJS.constants.iceRestartReason;
export const VietMeetMediaDevicesEvents = VietMeetJS.events.mediaDevices;
export const VietMeetTrackStreamingStatus = VietMeetJS.constants.trackStreamingStatus;
export const VietMeetRecordingConstants = VietMeetJS.constants.recording;
export const VietMeetSIPVideoGWStatus = VietMeetJS.constants.sipVideoGW;
export const VietMeetTrackErrors = VietMeetJS.errors.track;
export const VietMeetTrackEvents = VietMeetJS.events.track;
export const RTCStatsEvents = VietMeetJS.events.rtcstats;
